import React, { useState } from 'react';
import './ModalForm.css'; // optional for custom styles
import axios from 'axios';

const ModalForm = ({editprofile,userdata}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    dob: '',
    gender: '',
    address: '',
    photo: null,
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Enter a valid email';
    }

    if (formData.mobile && !/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number';
    }

    if (formData.dob && isNaN(new Date(formData.dob).getTime())) {
      newErrors.dob = 'Enter a valid date';
    }

    // if (!formData.gender) {
    //   newErrors.gender = 'Gender is required';
    // }

    if (formData.address && formData.address.length < 5) {
      newErrors.address = 'Address should be at least 5 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!validate()) return;
    let baseUrl = "";
    if (process.env.NODE_ENV === "production") {
      baseUrl = "https://imw-edu.com/edubackend";
    } else {
      baseUrl = "http://localhost/edubackend";
    }
    const url = `${baseUrl}/updateuser.php`;
    await axios.post(url,formData,{withCredentials:true}).then((res)=>{
        editprofile(false);
    })
    console.log(formData);
    // You can use axios/fetch to send formData
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content shadow">
          <div className="modal-header">
            <h5 className="modal-title">Update</h5>
            <button type="button" className="btn-close" onClick={()=>editprofile(false)}>X</button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body" style={{minWidth:"300px"}}>
              <div className="mb-3">
                <label className="form-label">Name *</label>
                <input type="text" className="form-control" name="name" value={formData.name?formData.name :formData.name=userdata.name} onChange={handleChange} required />
                {errors.name && <small className="text-danger">{errors.name}</small>}
              </div>

              <div className="mb-3">
                <label className="form-label">Email ID *</label>
                <input type="email" className="form-control" name="email" value={formData.email?formData.email:formData.email=userdata.email} onChange={handleChange} required />
                {errors.email && <small className="text-danger">{errors.email}</small>}
              </div>

              <div className="mb-3">
                <label className="form-label">Mobile Number</label>
                <input type="tel" className="form-control" name="mobile" value={formData.mobile?formData.mobile:formData.mobile=userdata.mobilenumber} onChange={handleChange} />
                {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
              </div>

              <div className="mb-3">
                <label className="form-label">Date Of Birth</label>
                <input type="date" className="form-control" name="dob" value={formData.dob?formData.dob:formData.dob=userdata.dob} onChange={handleChange} />
                {errors.dob && <small className="text-danger">{errors.dob}</small>}
              </div>

              <div className="mb-3">
                <label className="form-label">Gender</label>
                <select className="form-select" name="gender" value={formData.gender?formData.gender:formData.gender=userdata.gender} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  {/* <option value="Other">Other</option> */}
                </select>
                {errors.gender && <small className="text-danger">{errors.gender}</small>}
              </div>

              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea className="form-control" name="address" rows="2" value={formData.address?formData.address:formData.address=userdata.address} onChange={handleChange}></textarea>
                {errors.address && <small className="text-danger">{errors.address}</small>}
              </div>

              {/* <div className="mb-3">
                <label className="form-label">Photo</label>
                <input type="file" className="form-control" name="photo" onChange={handleChange} />
              </div> */}
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalForm;
